import axios from 'axios';
import _ from 'lodash';
import {
  axiosErrorHandler,
  helperConvertApiRoute,
  helperGetApiHeaders,
  helperGetApiRoute,
  helperGetApiRouteById,
  helperAppendToUrl,
} from 'helpers/ApiHelper';

import { getPrimetimeDateRange } from 'helpers/DateTimeHelper';
import { fetchFooter } from 'components/Footer/FooterActions';
import { getPrimeTimeNetworkFilter } from './LiveHelpers';

export const FETCH_LIVE = 'FETCH_LIVE';
export const FETCH_LIVE_PANEL = 'FETCH_LIVE_PANEL';
export const FETCH_LIVE_NEXT_PAGE = 'FETCH_LIVE_NEXT_PAGE';
export const FETCH_LIVESTREAM = 'FETCH_LIVESTREAM';
export const FETCH_PRIME_TIME = 'FETCH_PRIME_TIME';
export const SET_SUGGESTED_CHANNEL = 'SET_SUGGESTED_CHANNEL';
export const CLEAR_LIVE = 'CLEAR_LIVE';
export const SAVE_LIVE_VIDEO = 'SAVE_LIVE_VIDEO';
export const RESTORE_LIVE_GRID_STATE = 'RESTORE_LIVE_GRID_STATE';

function fetchNextPage({ accessToken, nextUrl: url, deviceId }) {
  const data = axios
    .get(url, helperGetApiHeaders({ accessToken, deviceId }))
    .catch(axiosErrorHandler);

  return {
    type: FETCH_LIVE_NEXT_PAGE,
    payload: data,
  };
}

function fetchLive({ accessToken, dateRange, network, deviceId }) {
  const pageType = 'live';
  let url = helperGetApiRoute(pageType);
  url = helperAppendToUrl({ url, network, dateRange });

  const request = axios
    .get(url, helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }))
    .catch(axiosErrorHandler);

  return {
    type: FETCH_LIVE,
    payload: request,
  };
}

export function fetchLiveAction({ accessToken, dateRange, coordinates, network, deviceId }) {
  return dispatch =>
    dispatch(fetchLive({ accessToken, dateRange, coordinates, network, deviceId }))
      .then(response => {
        const member = _.get(response, 'payload.data.panels.member', []);
        member.forEach(item => {
          const nextView = item?.items?.view?.next;
          if (nextView) {
            dispatch(fetchNextPage({ accessToken, nextUrl: nextView, deviceId }));
          }
        });
      })
      .then(() => dispatch(fetchFooter()));
}

export function fetchLivePanel({ accessToken, panelUrl, dateRange, network, deviceId }) {
  const pageType = 'live';
  let url = helperConvertApiRoute(panelUrl);
  url = helperAppendToUrl({ url, network, dateRange });

  const request = axios
    .get(url, helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }))
    .catch(axiosErrorHandler);

  return {
    type: FETCH_LIVE_PANEL,
    payload: request,
  };
}

export function fetchLivestream(accessToken, livestreamId, deviceId) {
  const pageType = 'live';
  const url = helperGetApiRouteById('livestream', livestreamId, '{epgListingId}', true);
  const request = axios
    .get(url, helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }))
    .catch(axiosErrorHandler);

  return {
    type: FETCH_LIVESTREAM,
    payload: request,
  };
}

export function fetchPrimeTime(accessToken, deviceId) {
  const pageType = 'foxPrimetime';
  const dateRange = getPrimetimeDateRange();
  let url = helperGetApiRoute(pageType);
  const network = getPrimeTimeNetworkFilter();

  url = helperAppendToUrl({ url, network, dateRange });

  const request = axios
    .get(url, helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }))
    .catch(axiosErrorHandler);

  return {
    type: FETCH_PRIME_TIME,
    payload: request,
  };
}

export function saveLiveVideo(video) {
  return {
    type: SAVE_LIVE_VIDEO,
    payload: video,
  };
}

export function setSuggestedChannel({ network, videoId, programId }) {
  return {
    type: SET_SUGGESTED_CHANNEL,
    payload: {
      data: {
        network,
        videoId,
        programId,
      },
    },
  };
}

export function clearLive() {
  return {
    type: CLEAR_LIVE,
  };
}

export function restoreLiveGridState(prevOpenRow, prevRowIdx) {
  return {
    type: RESTORE_LIVE_GRID_STATE,
    payload: {
      prevOpenRow,
      prevRowIdx,
    },
  };
}
